import uiRouter, { StateProvider } from '@uirouter/angularjs';
import angular from 'angular';

export const ProgramsListAdminOrderView = angular
  .module('acme.view.application.programs.list.admin.order', [
    uiRouter,
    'ui.bootstrap',
    'acme.view.application.programs.list.admin.order.controllers',
  ])
  .config(function config($stateProvider: StateProvider) {
    // Create both abstract view and template view.
    // Abstract Views are enabled by default

    $stateProvider.state({
      name: 'application.programs.listAdminOrder',
      url: '/order/:id',
      views: {
        'subview-main': {
          controller: 'ProgramsListAdminOrderController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/programs/list/admin/order/order.tpl.html',
        },
      },
      data: {
        pageTitle: 'Create Order',
        permissions: ['ORDER_CREATE'],
      },
      resolve: {
        EventData: [
          '$stateParams',
          'ApiService',
          function ($stateParams, ApiService) {
            return ApiService.program.instances.detail($stateParams.id);
          },
        ],
        SourceData: [
          'ApiService',
          function (ApiService) {
            return ApiService.walkins.sources.detail();
          },
        ],
      },
    });
  }).name;
